import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const Hamburger = ({ onClick, customStyles = {}, size = '2x' }) => {
  return (
    <FontAwesomeIcon
      style={{
        color: '#333',
        position: 'relative',
        zIndex: 10,
        cursor: 'pointer',
        ...customStyles
      }}
      size={size}
      icon={faBars}
      onClick={onClick}
    />
  );
};

export default Hamburger;
